import {useMutation, UseMutationResult} from '@tanstack/react-query'
import {api} from '../../../App.global'
import {ShipTo, ShipToRequestPayload} from '@hconnect/tuc-processes/shipToCreation'

export const createShipTo = async (data: ShipToRequestPayload): Promise<{data: ShipTo}> => {
  return api.post('/sites', data)
}

export const useCreateShipToMutation = (): UseMutationResult<
  {data: ShipTo},
  Error,
  ShipToRequestPayload
> => {
  return useMutation({
    mutationFn: createShipTo
  })
}
